module.exports = __webpack_public_path__ + "static/media/desktop.0d4b6bef.svg";